import { render } from "./FeedbackAttemptsBanner.vue?vue&type=template&id=54acd8a6&scoped=true"
import script from "./FeedbackAttemptsBanner.vue?vue&type=script&lang=js"
export * from "./FeedbackAttemptsBanner.vue?vue&type=script&lang=js"

import "./FeedbackAttemptsBanner.vue?vue&type=style&index=0&id=54acd8a6&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54acd8a6"]])

export default __exports__